import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularResizedEventModule } from 'angular-resize-event';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
// import { CaseStudyComponent } from './case-study/case-study.component';
// import { CounterComponent } from './counter/counter.component';
import { GenMixComponent } from './gen-mix/gen-mix.component';
import { HomeComponent } from './home/home.component';
import { IntroComponent } from './intro/intro.component';
import { IsoChartsComponent } from './iso-charts/iso-charts.component';
import { LmpChartComponent } from './lmp-chart/lmp-chart.component';
import { LoadChartComponent } from './load-chart/load-chart.component';
import { NavbarComponent } from './navbar/navbar.component';
import { OriginalComponent } from './original/original.component';
import { GenmixResolverService } from './services/genmix-resolver.service';
import { GoogleChartService } from './services/google-chart.service';
import { LmpResolverService } from './services/lmp-resolver.service';
import { LoadResolverService } from './services/load-resolver.service';
import { SignalrISOdataService } from './services/signalr-ISOdata.service';
import { YearHistChartComponent } from './year-hist-chart/year-hist-chart.component';
import { ProfileEditorComponent } from './profile-editor/profile-editor.component';
import { MonthlyDistComponent } from './monthly-dist/monthly-dist.component';

import { GridLoadChartsComponent } from './grid-load-charts/grid-load-charts.component';
import { RtoLoadResolverService } from './services/rto-load-resolver.service';
import { RtoSummerLoadsResolverService } from './services/rto-summer-loads-resolver.service';
import { RtoNonsummerLoadsResolverService } from './services/rto-nonsummer-loads-resolver.service';
import { PsegMonthlyLoadResolverService } from './services/pseg-monthly-load-resolver.service';
import { PsegMonthlyDistComponent } from './pseg-monthly-dist/pseg-monthly-dist.component';
import { RtoDistComponent } from './rto-dist/rto-dist.component';
import { PsegLoadChartComponent } from './pseg-load-chart/pseg-load-chart.component';
import { RtoLoadChartComponent } from './rto-load-chart/rto-load-chart.component';
import { PsegDemandManagementComponent } from './pseg-demand-management/pseg-demand-management.component';
import { RtoDemandManagementComponent } from './rto-demand-management/rto-demand-management.component';
import { PsegDemandResolverService } from './services/pseg-demand-resolver.service';
import { PsegHrlyLoadChartComponent } from './pseg-hrly-load-chart/pseg-hrly-load-chart.component';
import { PsegHrlyDemandResolverService } from './services/pseg-hrly-demand-resolver.service';
import { RtoHrlyLoadChartComponent } from './rto-hrly-load-chart/rto-hrly-load-chart.component';
import { RtoHrlyDemandResolverService } from './services/rto-hrly-demand-resolver.service';
import { RtoDemandResolverService } from './services/rto-demand-resolver.service';
import { HistNotSummerResolverService } from './services/hist-not-summer-resolver.service';
import { HistSummerResolverService } from './services/hist-summer-resolver.service';
import { Hist1YrResolverService } from './services/hist1-yr-resolver.service';
import { MonthlyDistService } from './services/monthly-dist.service';
import { ShaveTimeResolverService } from './services/shave-time-resolver.service';

@NgModule({
  declarations: [
    AppComponent,

    HomeComponent,
    NavbarComponent,
    IntroComponent,
    // CounterComponent,
    OriginalComponent,

    LoadChartComponent,

    IsoChartsComponent,
    LmpChartComponent,
    GenMixComponent,
    // MeterChartsComponent,
    // KwChartComponent,
    // CaseStudyComponent,

    YearHistChartComponent,
    // NameEditorComponent,
    // ProfileEditorComponent,
    MonthlyDistComponent,
    // GridMeterChartComponent,

    // GridLoadChartsComponent,
    PsegMonthlyDistComponent,
    RtoDistComponent,
    PsegLoadChartComponent,
    RtoLoadChartComponent,
    PsegDemandManagementComponent,
    RtoDemandManagementComponent,
    PsegHrlyLoadChartComponent,
    RtoHrlyLoadChartComponent,

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularResizedEventModule,
    RouterModule.forRoot([

      { path: '', component: HomeComponent },
      // 3. Optional: Handle old '/home' bookmarks by redirecting them to the base URL
      { path: 'home', redirectTo: '', pathMatch: 'full' },

      {
        path: 'app-iso-charts', component: IsoChartsComponent,
        resolve: { LmpData: LmpResolverService, LoadData: LoadResolverService, GenmixData: GenmixResolverService},

        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'app-iso-charts/app-lmp-chart',
            component: LmpChartComponent,

          },
          {
            path: 'app-iso-charts/app-load-chart',
            component: LoadChartComponent,
          },
          {
            path: 'app-iso-charts/app-gen-mix',
            component: GenMixComponent,
          }          
        ]

      },
      // {
      //   path: 'app-meter-charts', component: MeterChartsComponent,
      //   resolve:
      //   {
      //     MeterData: MeterResolverService,
      //     gridMeterData: GridmeterLoadResolverService,
      //     PeakLoadData: PeakLoadsResolverService,
      //   },

      //   runGuardsAndResolvers: 'always',

      // },

      // {

      //   path: 'app-case-study', component: CaseStudyComponent,

      //   resolve: {

      //     yearHistData: Hist1YrResolverService,
      //     summerHistData: HistSummerResolverService,
      //     nonSummerHistData: HistNotSummerResolverService,
      //     monthlyDistData: MonthlyDistService,

      //   },

      //   runGuardsAndResolvers: 'always',

      // },

      {

        path: 'app-grid-load-charts', component: GridLoadChartsComponent,

        resolve: {

          rtoYearHistData: RtoLoadResolverService,
          rtoSummerHistData: RtoSummerLoadsResolverService,
          rtoNonsummerHistData: RtoNonsummerLoadsResolverService,
          psegMonthlyDistData: PsegMonthlyLoadResolverService,

        },

        runGuardsAndResolvers: 'always',

      },
      {

        path: 'app-pseg-demand-management', component: PsegDemandManagementComponent,

        resolve: {

          yearHistData: Hist1YrResolverService,
          summerHistData: HistSummerResolverService,
          nonSummerHistData: HistNotSummerResolverService,
          //monthlyDistData: MonthlyDistService,

          psegMonthlyDistData: PsegMonthlyLoadResolverService,
          PsegLoadData: PsegDemandResolverService,
          PsegHrlyLoadData: PsegHrlyDemandResolverService,

        },

        runGuardsAndResolvers: 'always',

      },
      {

        path: 'app-rto-demand-management', component: RtoDemandManagementComponent,

        resolve: {


          rtoYearHistData: RtoLoadResolverService,
          rtoSummerHistData: RtoSummerLoadsResolverService,
          rtoNonsummerHistData: RtoNonsummerLoadsResolverService,
          RtoLoadData: RtoDemandResolverService,
          RtoHrlyLoadData: RtoHrlyDemandResolverService,
          ShaveTimesData: ShaveTimeResolverService,
        },

        runGuardsAndResolvers: 'always',

      },
      { path: 'app-intro', component: IntroComponent },
      { path: 'app-contact-us', component: ProfileEditorComponent },

      { path: '', redirectTo: '/home', pathMatch: 'full' }
    ],
      {
        onSameUrlNavigation: 'reload'
      }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [SignalrISOdataService, GoogleChartService, { provide: APP_BASE_HREF, useValue: ' ' } ],
  bootstrap: [AppComponent]
})
export class AppModule { }
